import React from 'react'

const UsersMenu: React.FC = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      width="32"
      height="32"
      rx="6.64935"
      fill="url(#paint0_linear_1037_33454)"
      fillOpacity="0.1"
    />
    <path
      d="M12.8677 23.5C11.0458 23.5 9.25192 23.5 7.43 23.5C6.56108 23.5 6.25276 23.1076 6.39291 22.2947C6.92547 19.2675 9.53221 16.9971 12.5594 16.885C15.7548 16.7729 18.5857 18.8751 19.3145 21.8743C19.6228 23.1076 19.3145 23.5 18.0532 23.5C16.3154 23.5 14.6056 23.5 12.8677 23.5Z"
      fill="#052351"
    />
    <path
      d="M12.8957 8.50464C14.8578 8.50464 16.4275 10.0463 16.4275 11.9803C16.4275 13.8583 14.7737 15.484 12.8677 15.484C10.9617 15.484 9.36401 13.8583 9.36401 11.9523C9.36401 10.0182 10.9056 8.50464 12.8957 8.50464Z"
      fill="#052351"
    />
    <path
      d="M19.0342 8.5042C20.5478 8.5042 21.7811 9.37312 22.3417 10.7466C22.9023 12.1761 22.5379 13.7177 21.4167 14.6987C20.4077 15.5957 18.782 15.8199 17.6047 15.2313C17.1843 15.0071 16.904 14.8949 17.3805 14.3624C18.5577 13.045 18.5577 11.195 17.4085 9.84962C16.932 9.28903 17.1002 9.09282 17.6327 8.84056C18.1093 8.58829 18.6138 8.47617 19.0342 8.5042Z"
      fill="#052351"
    />
    <path
      d="M20.9682 23.3595C21.4167 22.7709 21.2485 22.2383 21.1084 21.6777C20.6038 19.9119 19.5387 18.5664 17.941 17.6415C17.7168 17.5013 17.4085 17.4733 17.2683 17.193C20.8841 15.9597 25.1166 18.5945 25.6211 22.3224C25.7052 22.939 25.509 23.3315 24.8363 23.3315C23.5469 23.3595 22.3136 23.3595 20.9682 23.3595Z"
      fill="#052351"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1037_33454"
        x1="15.7922"
        y1="0"
        x2="15.7922"
        y2="32"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0062FF" />
        <stop offset="1" stopColor="#004BC2" />
      </linearGradient>
    </defs>
  </svg>
)

export default UsersMenu
